var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2638.33 1853.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1162.31,
    y1: 1490.42,
    x2: 746.03,
    y2: 1425.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffac06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7c0a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1825.43,
    y1: 295.82,
    x2: 1759.03,
    y2: 161.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1497.3,
    y1: 659.28,
    x2: 1819.7,
    y2: 652.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1497.3,
    y1: 657.06,
    x2: 1819.7,
    y2: 650.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2050.23,
    y1: 300.81,
    x2: 1544.06,
    y2: 300.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2037.84,
    y1: 298.27,
    x2: 1557.99,
    y2: 298.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#82fb7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ba2b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1956.86,
    y1: 634.39,
    x2: 1274.89,
    y2: 634.39,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1617.11,
    y1: 866.66,
    x2: 1616.44,
    y2: 725.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 21587.65,
    y1: -67.36,
    x2: 22048.78,
    y2: -67.36,
    gradientTransform: "translate(-19522.43 -2983.92) rotate(9.74) scale(.99 1.03) skewX(11.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 21772.59,
    y1: -108.87,
    x2: 21798.21,
    y2: -108.87,
    gradientTransform: "translate(-19522.43 -2983.92) rotate(9.74) scale(.99 1.03) skewX(11.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 21749.62,
    y1: -115.71,
    x2: 21775.3,
    y2: -115.71,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 21726.65,
    y1: -122.55,
    x2: 21752.39,
    y2: -122.55,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 21710.81,
    y1: -109.5,
    x2: 21737.23,
    y2: -109.5,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 21672.69,
    y1: -103.43,
    x2: 21698.51,
    y2: -103.43,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 21688.02,
    y1: -116.39,
    x2: 21714.26,
    y2: -116.39,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 21841.5,
    y1: -88.36,
    x2: 21866.95,
    y2: -88.36,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 21864.47,
    y1: -81.53,
    x2: 21889.86,
    y2: -81.53,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 21887.44,
    y1: -74.69,
    x2: 21912.77,
    y2: -74.69,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 21795.56,
    y1: -102.04,
    x2: 21821.12,
    y2: -102.04,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 21818.53,
    y1: -95.2,
    x2: 21844.03,
    y2: -95.2,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 21793.81,
    y1: -48.68,
    x2: 21819.92,
    y2: -48.68,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 21816.56,
    y1: -41.7,
    x2: 21842.71,
    y2: -41.7,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 21839.31,
    y1: -34.72,
    x2: 21865.5,
    y2: -34.72,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 21684.16,
    y1: -135.67,
    x2: 21706.56,
    y2: -135.67,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 21771.06,
    y1: -55.66,
    x2: 21797.13,
    y2: -55.66,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 21680.06,
    y1: -83.58,
    x2: 21705.97,
    y2: -83.58,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 21862.06,
    y1: -27.75,
    x2: 21888.29,
    y2: -27.75,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 21725.56,
    y1: -69.62,
    x2: 21751.55,
    y2: -69.62,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 21748.31,
    y1: -62.64,
    x2: 21774.34,
    y2: -62.64,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 21695.49,
    y1: -96.47,
    x2: 21721.3,
    y2: -96.47,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 21779.19,
    y1: -88.84,
    x2: 21806.14,
    y2: -88.84,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 21756.4,
    y1: -95.73,
    x2: 21783.17,
    y2: -95.73,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 21718.28,
    y1: -89.5,
    x2: 21744.09,
    y2: -89.5,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 21801.98,
    y1: -81.95,
    x2: 21829.11,
    y2: -81.95,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 21733.61,
    y1: -102.61,
    x2: 21760.2,
    y2: -102.61,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 21824.77,
    y1: -75.06,
    x2: 21852.08,
    y2: -75.06,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 21718.93,
    y1: -141.62,
    x2: 21743.83,
    y2: -141.62,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 21741.07,
    y1: -82.54,
    x2: 21766.88,
    y2: -82.54,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 21847.56,
    y1: -68.18,
    x2: 21875.05,
    y2: -68.18,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 21870.35,
    y1: -61.29,
    x2: 21898.02,
    y2: -61.29,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 21855.02,
    y1: -47.73,
    x2: 21880.83,
    y2: -47.73,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 21893.14,
    y1: -54.4,
    x2: 21920.99,
    y2: -54.4,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 21915.93,
    y1: -47.52,
    x2: 21943.96,
    y2: -47.52,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 21763.86,
    y1: -75.58,
    x2: 21789.67,
    y2: -75.58,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 21877.81,
    y1: -40.77,
    x2: 21903.62,
    y2: -40.77,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 21933.38,
    y1: -61.02,
    x2: 21958.59,
    y2: -61.02,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 21786.65,
    y1: -68.62,
    x2: 21812.46,
    y2: -68.62,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 21809.44,
    y1: -61.65,
    x2: 21835.25,
    y2: -61.65,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 21910.41,
    y1: -67.85,
    x2: 21935.68,
    y2: -67.85,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 21832.23,
    y1: -54.69,
    x2: 21858.04,
    y2: -54.69,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 21702.81,
    y1: -76.6,
    x2: 21728.76,
    y2: -76.6,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 21795.22,
    y1: -26.18,
    x2: 21827.03,
    y2: -26.18,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 21636.66,
    y1: -75.45,
    x2: 21667.78,
    y2: -75.45,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 21840.52,
    y1: -12.11,
    x2: 21872.53,
    y2: -12.11,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 21817.87,
    y1: -19.14,
    x2: 21849.78,
    y2: -19.14,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 21602.12,
    y1: 49.86,
    x2: 21759.25,
    y2: 49.86,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 21863.17,
    y1: -5.07,
    x2: 21895.27,
    y2: -5.07,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 21681.96,
    y1: -61.37,
    x2: 21713.28,
    y2: -61.37,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 21659.31,
    y1: -68.41,
    x2: 21690.53,
    y2: -68.41,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 21704.61,
    y1: -43.71,
    x2: 21804.28,
    y2: -43.71,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 21700.19,
    y1: -146.18,
    x2: 21720.31,
    y2: -146.18,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 21979.32,
    y1: -47.43,
    x2: 22003.7,
    y2: -47.43,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 21993.87,
    y1: -61.67,
    x2: 22013.17,
    y2: -61.67,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 21623.25,
    y1: -82.15,
    x2: 21645.03,
    y2: -82.15,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 21908.47,
    y1: 7.99,
    x2: 21941.3,
    y2: 7.99,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 21907.56,
    y1: -13.79,
    x2: 21933.87,
    y2: -13.79,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 21961.51,
    y1: -33.77,
    x2: 21989.46,
    y2: -33.77,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 21930.31,
    y1: -6.74,
    x2: 21956.88,
    y2: -6.74,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 21885.82,
    y1: 1.97,
    x2: 21918.02,
    y2: 1.97,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 21652.61,
    y1: -109.94,
    x2: 21675.72,
    y2: -109.94,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 21925.13,
    y1: -81.6,
    x2: 21954.15,
    y2: -81.6,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 21948.04,
    y1: -74.93,
    x2: 21977.52,
    y2: -74.93,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 21902.22,
    y1: -88.27,
    x2: 21930.78,
    y2: -88.27,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 21970.96,
    y1: -68.26,
    x2: 22000.89,
    y2: -68.26,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 21879.31,
    y1: -94.94,
    x2: 21907.41,
    y2: -94.94,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 21956.35,
    y1: -54.18,
    x2: 21981.51,
    y2: -54.18,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 21900.6,
    y1: -33.8,
    x2: 21926.41,
    y2: -33.8,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 21856.4,
    y1: -101.61,
    x2: 21884.04,
    y2: -101.61,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 21923.39,
    y1: -23.34,
    x2: 21971.91,
    y2: -23.34,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 21938.72,
    y1: -40.63,
    x2: 21966.93,
    y2: -40.63,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 21668.3,
    y1: -122.78,
    x2: 21691.29,
    y2: -122.78,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 21884.81,
    y1: -20.77,
    x2: 21911.08,
    y2: -20.77,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 21657.31,
    y1: -90.56,
    x2: 21683.18,
    y2: -90.56,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 21636.9,
    y1: -97.14,
    x2: 21660.39,
    y2: -97.14,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 21703.68,
    y1: -129.38,
    x2: 21729.48,
    y2: -129.38,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 21810.57,
    y1: -114.94,
    x2: 21837.3,
    y2: -114.94,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 21833.49,
    y1: -108.28,
    x2: 21860.67,
    y2: -108.28,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 21787.66,
    y1: -121.61,
    x2: 21813.93,
    y2: -121.61,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 21741.84,
    y1: -134.95,
    x2: 21767.2,
    y2: -134.95,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 21764.75,
    y1: -128.28,
    x2: 21790.57,
    y2: -128.28,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 706.23,
    y1: 187.2,
    x2: 743.2,
    y2: 643.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdfdfd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 1327.83,
    y1: 794.15,
    x2: 1820.66,
    y2: 1562.97,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 843.63,
    y1: 528.89,
    x2: 971.76,
    y2: 1002.01,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 1629.16,
    y1: 864.98,
    x2: 1649.43,
    y2: 864.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 1972.67,
    y1: 1372.95,
    x2: 1974.69,
    y2: 1372.95,
    xlinkHref: "#linear-gradient-94"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 2251.26,
    y1: 1225.22,
    x2: 2320.26,
    y2: 1668.77,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 347.03,
    y1: 778.11,
    x2: 667.59,
    y2: 778.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0d0d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 666.85,
    y1: 836.12,
    x2: 668.17,
    y2: 836.12,
    xlinkHref: "#linear-gradient-94"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 793.67,
    y1: 658.49,
    x2: 1319.29,
    y2: 658.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#388277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ba2b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 820.91,
    y1: 637.17,
    x2: 1346.53,
    y2: 637.17,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 1083.74,
    y1: 663.6,
    x2: 1346.53,
    y2: 663.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 1083.74,
    y1: 511.1,
    x2: 1292.12,
    y2: 511.1,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 889.98,
    y1: 1053.27,
    x2: 1250.22,
    y2: 1053.27,
    xlinkHref: "#linear-gradient-97"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 1746.66,
    y1: 1482.03,
    x2: 2073.32,
    y2: 1482.03,
    xlinkHref: "#linear-gradient-97"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 256.06,
    y1: 957.16,
    x2: 2110.54,
    y2: 957.16,
    xlinkHref: "#linear-gradient-97"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 2362.34,
    y1: 1435.62,
    x2: 2529.94,
    y2: 1435.62,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 2479.45,
    y1: 1444.37,
    x2: 2529.94,
    y2: 1444.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 2450.65,
    y1: 1383.48,
    x2: 2517.52,
    y2: 1383.48,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 1827.49,
    y1: 1074.94,
    x2: 2176.19,
    y2: 1074.94,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 1845.56,
    y1: 1060.81,
    x2: 2194.25,
    y2: 1060.81,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 1793.74,
    y1: 413.14,
    x2: 1950.42,
    y2: 413.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 715.35,
    y1: 1420.63,
    x2: 1236.21,
    y2: 1420.63,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 452.89,
    ry: 215.37,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#4c0000",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 441.22,
    ry: 209.82,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#4a0101",
      opacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 429.56,
    ry: 204.27,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#480202",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 417.89,
    ry: 198.73,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#460303",
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 406.22,
    ry: 193.18,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#440404",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 394.56,
    ry: 187.63,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#420505",
      opacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 382.89,
    ry: 182.08,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#400606",
      opacity: 0.23
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 371.23,
    ry: 176.53,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#3e0606",
      opacity: 0.27
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 359.56,
    ry: 170.99,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#3c0707",
      opacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 347.89,
    ry: 165.44,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#3a0808",
      opacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 336.23,
    ry: 159.89,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#380909",
      opacity: 0.38
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 324.56,
    ry: 154.34,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#360a0a",
      opacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 312.9,
    ry: 148.8,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#340b0b",
      opacity: 0.46
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 301.23,
    ry: 143.25,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#330c0c",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 289.57,
    ry: 137.7,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#310d0d",
      opacity: 0.54
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 277.9,
    ry: 132.15,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#2f0e0e",
      opacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 266.23,
    ry: 126.61,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#2d0f0f",
      opacity: 0.62
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 254.57,
    ry: 121.06,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#2b1010",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 242.9,
    ry: 115.51,
    transform: "translate(-21.68 42.61) rotate(-1.5)",
    style: {
      fill: "#291111",
      opacity: 0.69
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 231.24,
    ry: 109.96,
    transform: "translate(-21.68 42.6) rotate(-1.5)",
    style: {
      fill: "#271212",
      opacity: 0.73
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.63,
    cy: 846.75,
    rx: 219.57,
    ry: 104.41,
    transform: "translate(-21.68 42.6) rotate(-1.5)",
    style: {
      fill: "#251212",
      opacity: 0.77
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.64,
    cy: 846.75,
    rx: 207.9,
    ry: 98.87,
    transform: "translate(-21.67 42.6) rotate(-1.5)",
    style: {
      fill: "#231313",
      opacity: 0.81
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.64,
    cy: 846.75,
    rx: 196.24,
    ry: 93.32,
    transform: "translate(-21.67 42.6) rotate(-1.5)",
    style: {
      fill: "#211414",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.64,
    cy: 846.75,
    rx: 184.57,
    ry: 87.77,
    transform: "translate(-21.67 42.6) rotate(-1.5)",
    style: {
      fill: "#1f1515",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.64,
    cy: 846.75,
    rx: 172.91,
    ry: 82.22,
    transform: "translate(-21.67 42.6) rotate(-1.5)",
    style: {
      fill: "#1d1616",
      opacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.64,
    cy: 846.75,
    rx: 161.24,
    ry: 76.68,
    transform: "translate(-21.67 42.6) rotate(-1.5)",
    style: {
      fill: "#1b1717",
      opacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1611.64,
    cy: 846.75,
    rx: 149.57,
    ry: 71.13,
    transform: "translate(-21.67 42.6) rotate(-1.5)",
    style: {
      fill: "#191818"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.77,
    cy: 1686.34,
    rx: 261.83,
    ry: 124.51,
    transform: "translate(-43.95 26.21) rotate(-1.5)",
    style: {
      fill: "#4c0000",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 255.08,
    ry: 121.3,
    transform: "translate(-43.95 26.21) rotate(-1.5)",
    style: {
      fill: "#4a0101",
      opacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 248.34,
    ry: 118.1,
    transform: "translate(-43.95 26.21) rotate(-1.5)",
    style: {
      fill: "#480202",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 241.59,
    ry: 114.89,
    transform: "translate(-43.95 26.21) rotate(-1.5)",
    style: {
      fill: "#460303",
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 234.85,
    ry: 111.68,
    transform: "translate(-43.95 26.21) rotate(-1.5)",
    style: {
      fill: "#440404",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 228.11,
    ry: 108.47,
    transform: "translate(-43.95 26.21) rotate(-1.5)",
    style: {
      fill: "#420505",
      opacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 221.36,
    ry: 105.27,
    transform: "translate(-43.95 26.21) rotate(-1.5)",
    style: {
      fill: "#400606",
      opacity: 0.23
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 214.62,
    ry: 102.06,
    transform: "translate(-43.95 26.21) rotate(-1.5)",
    style: {
      fill: "#3e0606",
      opacity: 0.27
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 207.87,
    ry: 98.85,
    transform: "translate(-43.95 26.21) rotate(-1.5)",
    style: {
      fill: "#3c0707",
      opacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 201.13,
    ry: 95.65,
    transform: "translate(-43.95 26.2) rotate(-1.5)",
    style: {
      fill: "#3a0808",
      opacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 194.38,
    ry: 92.44,
    transform: "translate(-43.95 26.21) rotate(-1.5)",
    style: {
      fill: "#380909",
      opacity: 0.38
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 187.64,
    ry: 89.23,
    transform: "translate(-43.95 26.21) rotate(-1.5)",
    style: {
      fill: "#360a0a",
      opacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 180.9,
    ry: 86.02,
    transform: "translate(-43.95 26.21) rotate(-1.5)",
    style: {
      fill: "#340b0b",
      opacity: 0.46
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 174.15,
    ry: 82.82,
    transform: "translate(-43.94 26.2) rotate(-1.5)",
    style: {
      fill: "#330c0c",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 167.41,
    ry: 79.61,
    transform: "translate(-43.94 26.2) rotate(-1.5)",
    style: {
      fill: "#310d0d",
      opacity: 0.54
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 160.66,
    ry: 76.4,
    transform: "translate(-43.94 26.2) rotate(-1.5)",
    style: {
      fill: "#2f0e0e",
      opacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 153.92,
    ry: 73.19,
    transform: "translate(-43.94 26.2) rotate(-1.5)",
    style: {
      fill: "#2d0f0f",
      opacity: 0.62
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 147.17,
    ry: 69.99,
    transform: "translate(-43.94 26.2) rotate(-1.5)",
    style: {
      fill: "#2b1010",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 140.43,
    ry: 66.78,
    transform: "translate(-43.94 26.2) rotate(-1.5)",
    style: {
      fill: "#291111",
      opacity: 0.69
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 133.68,
    ry: 63.57,
    transform: "translate(-43.94 26.2) rotate(-1.5)",
    style: {
      fill: "#271212",
      opacity: 0.73
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 126.94,
    ry: 60.37,
    transform: "translate(-43.94 26.2) rotate(-1.5)",
    style: {
      fill: "#251212",
      opacity: 0.77
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 120.2,
    ry: 57.16,
    transform: "translate(-43.94 26.2) rotate(-1.5)",
    style: {
      fill: "#231313",
      opacity: 0.81
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 113.45,
    ry: 53.95,
    transform: "translate(-43.94 26.2) rotate(-1.5)",
    style: {
      fill: "#211414",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 106.71,
    ry: 50.74,
    transform: "translate(-43.94 26.2) rotate(-1.5)",
    style: {
      fill: "#1f1515",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 99.96,
    ry: 47.54,
    transform: "translate(-43.94 26.2) rotate(-1.5)",
    style: {
      fill: "#1d1616",
      opacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 93.22,
    ry: 44.33,
    transform: "translate(-43.94 26.2) rotate(-1.5)",
    style: {
      fill: "#1b1717",
      opacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.78,
    cy: 1686.34,
    rx: 86.47,
    ry: 41.12,
    transform: "translate(-43.93 26.2) rotate(-1.5)",
    style: {
      fill: "#191818"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 261.83,
    ry: 124.51,
    transform: "translate(-32.24 52.24) rotate(-1.5)",
    style: {
      fill: "#4c0000",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 255.08,
    ry: 121.3,
    transform: "translate(-32.24 52.24) rotate(-1.5)",
    style: {
      fill: "#4a0101",
      opacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 248.34,
    ry: 118.1,
    transform: "translate(-32.24 52.24) rotate(-1.5)",
    style: {
      fill: "#480202",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 241.59,
    ry: 114.89,
    transform: "translate(-32.24 52.24) rotate(-1.5)",
    style: {
      fill: "#460303",
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 234.85,
    ry: 111.68,
    transform: "translate(-32.24 52.24) rotate(-1.5)",
    style: {
      fill: "#440404",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 228.11,
    ry: 108.47,
    transform: "translate(-32.24 52.24) rotate(-1.5)",
    style: {
      fill: "#420505",
      opacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 221.36,
    ry: 105.27,
    transform: "translate(-32.24 52.24) rotate(-1.5)",
    style: {
      fill: "#400606",
      opacity: 0.23
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 214.62,
    ry: 102.06,
    transform: "translate(-32.24 52.24) rotate(-1.5)",
    style: {
      fill: "#3e0606",
      opacity: 0.27
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 207.87,
    ry: 98.85,
    transform: "translate(-32.24 52.23) rotate(-1.5)",
    style: {
      fill: "#3c0707",
      opacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 201.13,
    ry: 95.65,
    transform: "translate(-32.24 52.23) rotate(-1.5)",
    style: {
      fill: "#3a0808",
      opacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 194.38,
    ry: 92.44,
    transform: "translate(-32.24 52.23) rotate(-1.5)",
    style: {
      fill: "#380909",
      opacity: 0.38
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 187.64,
    ry: 89.23,
    transform: "translate(-32.24 52.23) rotate(-1.5)",
    style: {
      fill: "#360a0a",
      opacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 180.9,
    ry: 86.02,
    transform: "translate(-32.24 52.23) rotate(-1.5)",
    style: {
      fill: "#340b0b",
      opacity: 0.46
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 174.15,
    ry: 82.82,
    transform: "translate(-32.24 52.23) rotate(-1.5)",
    style: {
      fill: "#330c0c",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 167.41,
    ry: 79.61,
    transform: "translate(-32.24 52.23) rotate(-1.5)",
    style: {
      fill: "#310d0d",
      opacity: 0.54
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 160.66,
    ry: 76.4,
    transform: "translate(-32.24 52.23) rotate(-1.5)",
    style: {
      fill: "#2f0e0e",
      opacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 153.92,
    ry: 73.19,
    transform: "translate(-32.24 52.23) rotate(-1.5)",
    style: {
      fill: "#2d0f0f",
      opacity: 0.62
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 147.17,
    ry: 69.99,
    transform: "translate(-32.24 52.23) rotate(-1.5)",
    style: {
      fill: "#2b1010",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 140.43,
    ry: 66.78,
    transform: "translate(-32.24 52.23) rotate(-1.5)",
    style: {
      fill: "#291111",
      opacity: 0.69
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 133.68,
    ry: 63.57,
    transform: "translate(-32.24 52.23) rotate(-1.5)",
    style: {
      fill: "#271212",
      opacity: 0.73
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 126.94,
    ry: 60.37,
    transform: "translate(-32.24 52.23) rotate(-1.5)",
    style: {
      fill: "#251212",
      opacity: 0.77
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 120.2,
    ry: 57.16,
    transform: "translate(-32.23 52.23) rotate(-1.5)",
    style: {
      fill: "#231313",
      opacity: 0.81
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 113.45,
    ry: 53.95,
    transform: "translate(-32.23 52.22) rotate(-1.5)",
    style: {
      fill: "#211414",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 106.71,
    ry: 50.74,
    transform: "translate(-32.23 52.22) rotate(-1.5)",
    style: {
      fill: "#1f1515",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.67,
    cy: 1253.62,
    rx: 99.96,
    ry: 47.54,
    transform: "translate(-32.23 52.22) rotate(-1.5)",
    style: {
      fill: "#1d1616",
      opacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.68,
    cy: 1253.62,
    rx: 93.22,
    ry: 44.33,
    transform: "translate(-32.23 52.22) rotate(-1.5)",
    style: {
      fill: "#1b1717",
      opacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1972.68,
    cy: 1253.62,
    rx: 86.47,
    ry: 41.12,
    transform: "translate(-32.23 52.22) rotate(-1.5)",
    style: {
      fill: "#191818"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M729.97,1298.32l315.05-63.38c17.66-5.22,36.49,3.2,44.37,19.85l146.82,248.86c9.34,19.74-17.62,68.7-38.3,75.73l-307.17,104.39c-23.41,7.96-49.04-3.17-59.21-25.7l-126.49-280.11c-8.94-19.8,4.1-73.48,24.93-79.64Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1664.51,1.17l384.06,118.87c13.39,4.14,21.41,17.81,18.51,31.52l-92.78,438.14-17.44,5.97-395.36-187.6L1631.35,21.32c2.77-15.31,18.3-24.75,33.17-20.15Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548.02,436.52l-269.17,170.68c-9.24,6.63-2.05,38.47,7.73,44.25l372.78,220.46c14.91,8.82,33.87,6.55,46.29-5.52l255.17-248.24-3.97-20.27-408.84-161.36Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548.02,434.3l-269.17,170.68c-9.24,6.63-2.05,38.47,7.73,44.25l372.78,220.46c14.91,8.82,33.87,6.55,46.29-5.52l255.17-248.24-3.97-20.27-408.84-161.36Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1647.08,7.13l384.06,118.87c13.39,4.14,21.41,17.81,18.51,31.52l-92.78,438.14-412.8-181.63L1613.91,27.29c2.77-15.31,18.3-24.75,33.17-20.15Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1557.99,406.62L1626.11,29.49c1.16-6.45,6.75-11.13,13.29-11.13,1.35,0,2.7,.21,4.02,.61l384.06,118.87c7.31,2.26,11.63,9.62,10.05,17.11l-89.62,423.22-389.9-171.56Z",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.06,414.03l-262.61,188.58c-9.24,6.63-8.62,20.57,1.17,26.35l372.78,220.46c14.91,8.82,33.87,6.55,46.29-5.52l255.17-248.24-412.8-181.63Z",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.69,841.67c-12.41,12.08-31.38,14.34-46.29,5.52l-372.78-220.46c-4.79-2.84-7.37-7.63-7.69-12.56-.43,5.67,2.17,11.52,7.69,14.78l372.78,220.46c14.91,8.82,33.87,6.55,46.29-5.52l255.17-248.24-1.57-.69-253.6,246.71Z",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1535.98,457.99l-94.78,66.76c-5.5,2.85-4.26,12.12,2.06,15.37l324.7,164.17c7.09,3.64,14.76,3.33,20.33-.84l93.87-73.05c6.32-4.73,3.85-16.33-4.28-20.14l-313.87-151.95c-9.59-4.49-19.77-4.61-28.03-.32Z",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1616.74 531.07 1632.45 538.75 1641.56 531.97 1625.89 524.27 1616.74 531.07",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1594.31 520.11 1610.02 527.79 1619.18 520.97 1603.51 513.27 1594.31 520.11",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1571.88 509.15 1587.59 516.83 1596.81 509.97 1581.14 502.27 1571.88 509.15",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1556.75 520.4 1572.34 528.16 1582.33 520.74 1566.62 513.06 1556.75 520.4",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1519.85 520.2 1535.44 527.96 1544.85 520.96 1529.26 513.2 1519.85 520.2",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1534.49 509.31 1550.08 517.07 1559.9 509.78 1544.19 502.1 1534.49 509.31",
    style: {
      fill: "url(#linear-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1684.04 563.95 1699.75 571.63 1708.69 564.98 1693.02 557.28 1684.04 563.95",
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1706.47 574.92 1722.18 582.59 1731.06 575.98 1715.39 568.28 1706.47 574.92",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1728.9 585.88 1744.61 593.55 1753.44 586.99 1737.77 579.28 1728.9 585.88",
    style: {
      fill: "url(#linear-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1639.17 542.03 1654.88 549.71 1663.93 542.98 1648.26 535.27 1639.17 542.03",
    style: {
      fill: "url(#linear-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1661.61 552.99 1677.31 560.67 1686.31 553.98 1670.64 546.27 1661.61 552.99",
    style: {
      fill: "url(#linear-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1663.77 598.38 1648.18 590.62 1638.48 597.83 1654.04 605.61 1663.77 598.38",
    style: {
      fill: "url(#linear-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1686.03 609.47 1670.44 601.71 1660.7 608.94 1676.27 616.73 1686.03 609.47",
    style: {
      fill: "url(#linear-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1708.29 620.56 1692.7 612.8 1682.93 620.06 1698.49 627.85 1708.29 620.56",
    style: {
      fill: "url(#linear-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1552.05 487.97 1539.97 482.02 1530.39 488.87 1542.72 494.9 1552.05 487.97",
    style: {
      fill: "url(#linear-gradient-24)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1641.51 587.3 1625.92 579.53 1616.26 586.71 1631.82 594.5 1641.51 587.3",
    style: {
      fill: "url(#linear-gradient-25)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1552.47 542.94 1536.88 535.18 1527.38 542.24 1542.94 550.03 1552.47 542.94",
    style: {
      fill: "url(#linear-gradient-26)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1730.55 631.65 1714.96 623.88 1705.15 631.18 1720.71 638.96 1730.55 631.65",
    style: {
      fill: "url(#linear-gradient-27)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1596.99 565.12 1581.4 557.35 1571.82 564.48 1587.38 572.26 1596.99 565.12",
    style: {
      fill: "url(#linear-gradient-28)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1619.25 576.21 1603.66 568.44 1594.04 575.59 1609.6 583.38 1619.25 576.21",
    style: {
      fill: "url(#linear-gradient-29)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1542.11 531.29 1557.7 539.05 1567.11 532.05 1551.52 524.29 1542.11 531.29",
    style: {
      fill: "url(#linear-gradient-30)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1623.53 553.66 1639.12 561.43 1649.62 553.62 1633.91 545.94 1623.53 553.66",
    style: {
      fill: "url(#linear-gradient-31)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1601.27 542.57 1616.86 550.34 1627.19 542.66 1611.48 534.98 1601.27 542.57",
    style: {
      fill: "url(#linear-gradient-32)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1589.37 543.14 1573.78 535.38 1564.37 542.37 1579.96 550.14 1589.37 543.14",
    style: {
      fill: "url(#linear-gradient-33)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1645.79 564.75 1661.38 572.52 1672.06 564.58 1656.35 556.9 1645.79 564.75",
    style: {
      fill: "url(#linear-gradient-34)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1579.01 531.49 1594.6 539.25 1604.76 531.7 1589.05 524.02 1579.01 531.49",
    style: {
      fill: "url(#linear-gradient-35)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1668.05 575.84 1683.64 583.61 1694.49 575.54 1678.78 567.87 1668.05 575.84",
    style: {
      fill: "url(#linear-gradient-36)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1579.68 495.06 1588.14 488.77 1572.16 481.3 1564.01 487.36 1579.68 495.06",
    style: {
      fill: "url(#linear-gradient-37)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1611.63 554.23 1596.04 546.46 1586.63 553.46 1602.22 561.23 1611.63 554.23",
    style: {
      fill: "url(#linear-gradient-38)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1690.31 586.93 1705.9 594.69 1716.92 586.5 1701.21 578.83 1690.31 586.93",
    style: {
      fill: "url(#linear-gradient-39)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1739.35 597.46 1723.64 589.79 1712.57 598.02 1728.16 605.78 1739.35 597.46",
    style: {
      fill: "url(#linear-gradient-40)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1722.93 609.67 1707.34 601.91 1697.93 608.91 1713.52 616.67 1722.93 609.67",
    style: {
      fill: "url(#linear-gradient-41)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1761.78 608.42 1746.07 600.75 1734.83 609.11 1750.42 616.87 1761.78 608.42",
    style: {
      fill: "url(#linear-gradient-42)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1784.21 619.38 1768.51 611.71 1757.09 620.19 1772.68 627.96 1784.21 619.38",
    style: {
      fill: "url(#linear-gradient-43)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1633.89 565.32 1618.3 557.55 1608.89 564.55 1624.48 572.32 1633.89 565.32",
    style: {
      fill: "url(#linear-gradient-44)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1745.19 620.76 1729.6 613 1720.19 619.99 1735.78 627.76 1745.19 620.76",
    style: {
      fill: "url(#linear-gradient-45)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1798.19 608.99 1782.52 601.29 1773.76 607.8 1789.47 615.47 1798.19 608.99",
    style: {
      fill: "url(#linear-gradient-46)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1656.15 576.41 1640.56 568.64 1631.15 575.64 1646.74 583.41 1656.15 576.41",
    style: {
      fill: "url(#linear-gradient-47)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1678.41 587.5 1662.82 579.73 1653.41 586.73 1669 594.49 1678.41 587.5",
    style: {
      fill: "url(#linear-gradient-48)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1751.33 596.84 1767.04 604.51 1775.82 597.99 1760.15 590.28 1751.33 596.84",
    style: {
      fill: "url(#linear-gradient-49)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1700.67 598.58 1685.08 590.82 1675.67 597.82 1691.26 605.58 1700.67 598.58",
    style: {
      fill: "url(#linear-gradient-50)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1574.73 554.03 1559.14 546.26 1549.6 553.36 1565.16 561.14 1574.73 554.03",
    style: {
      fill: "url(#linear-gradient-51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1655.48 612.83 1640.31 624.11 1655.81 631.94 1671.04 620.61 1655.48 612.83",
    style: {
      fill: "url(#linear-gradient-52)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1499.93 535.01 1485.43 545.79 1500.92 553.63 1515.49 542.79 1499.93 535.01",
    style: {
      fill: "url(#linear-gradient-53)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1699.92 635.06 1684.57 646.48 1700.06 654.32 1715.49 642.85 1699.92 635.06",
    style: {
      fill: "url(#linear-gradient-54)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1677.7 623.95 1662.44 635.29 1677.94 643.13 1693.26 631.73 1677.7 623.95",
    style: {
      fill: "url(#linear-gradient-55)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1513.62 631.54 1454.31 675.64 1544.81 728.62 1606.46 677.99 1513.62 631.54",
    style: {
      fill: "url(#linear-gradient-56)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1722.15 646.18 1706.69 657.67 1722.19 665.5 1737.71 653.97 1722.15 646.18",
    style: {
      fill: "url(#linear-gradient-57)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1544.37 557.24 1529.68 568.17 1545.17 576 1559.93 565.03 1544.37 557.24",
    style: {
      fill: "url(#linear-gradient-58)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1522.15 546.13 1507.55 556.98 1523.05 564.82 1537.71 553.91 1522.15 546.13",
    style: {
      fill: "url(#linear-gradient-59)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1648.82 609.5 1566.59 568.36 1551.81 579.36 1579.1 593.16 1589.43 598.38 1589.43 598.38 1606.39 606.95 1611.56 609.57 1611.56 609.57 1633.68 620.75 1648.82 609.5",
    style: {
      fill: "url(#linear-gradient-60)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1565.18,478.2c-6.71-2.38-13.57-2.33-19.48,.16l11.6,5.7,7.88-5.86Z",
    style: {
      fill: "url(#linear-gradient-61)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1818.63 629.72 1833.8 637.14 1842.24 630.65 1827.27 623.29 1818.63 629.72",
    style: {
      fill: "url(#linear-gradient-62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.81,609.51l-13.28,9.88,14.86,7.31,.75-.58c5.08-3.8,3.58-12.74-2.32-16.61Z",
    style: {
      fill: "url(#linear-gradient-63)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.87,524.97l-4.63,3.31c-4.74,2.46-3.67,10.46,1.78,13.26l1.78,.9,14.48-10.76-13.4-6.7Z",
    style: {
      fill: "url(#linear-gradient-64)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.95,680.05l6.31,3.19c6.12,3.14,12.74,2.87,17.54-.72l7.87-6.05-16.08-8.04-15.64,11.63Z",
    style: {
      fill: "url(#linear-gradient-65)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1775.07 653.83 1759.48 646.06 1749.59 653.41 1765.15 661.2 1775.07 653.83",
    style: {
      fill: "url(#linear-gradient-66)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1801.61 642.37 1817.02 650.04 1828.65 641.1 1813.37 633.63 1801.61 642.37",
    style: {
      fill: "url(#linear-gradient-67)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1771.81 664.53 1787.79 672.52 1797.54 665.02 1781.74 657.15 1771.81 664.53",
    style: {
      fill: "url(#linear-gradient-68)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1744.37 657.3 1728.82 668.86 1744.32 676.69 1759.93 665.08 1744.37 657.3",
    style: {
      fill: "url(#linear-gradient-69)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1522.59 509.88 1509.86 503.54 1500.23 510.42 1513.17 516.87 1522.59 509.88",
    style: {
      fill: "url(#linear-gradient-70)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1781.07 594.08 1793.46 584.87 1777.48 577.39 1765.4 586.38 1781.07 594.08",
    style: {
      fill: "url(#linear-gradient-71)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1803.44 605.09 1816.27 595.55 1800.29 588.07 1787.77 597.38 1803.44 605.09",
    style: {
      fill: "url(#linear-gradient-72)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1758.69 583.08 1770.64 574.19 1754.67 566.72 1743.02 575.38 1758.69 583.08",
    style: {
      fill: "url(#linear-gradient-73)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1825.82 616.09 1839.08 606.23 1823.11 598.75 1810.15 608.38 1825.82 616.09",
    style: {
      fill: "url(#linear-gradient-74)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1736.31 572.08 1747.83 563.52 1731.85 556.04 1720.64 564.37 1736.31 572.08",
    style: {
      fill: "url(#linear-gradient-75)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1820.57 619.99 1804.9 612.29 1796.2 618.76 1811.91 626.44 1820.57 619.99",
    style: {
      fill: "url(#linear-gradient-76)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1751.86 624.08 1742.45 631.08 1758.04 638.85 1767.45 631.85 1751.86 624.08",
    style: {
      fill: "url(#linear-gradient-77)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1713.94 561.08 1725.02 552.84 1709.04 545.36 1698.27 553.37 1713.94 561.08",
    style: {
      fill: "url(#linear-gradient-78)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1789.71 642.94 1774.12 635.17 1764.71 642.17 1802.67 661.08 1811.89 653.99 1789.71 642.94 1789.71 642.94",
    style: {
      fill: "url(#linear-gradient-79)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1806.65 630.35 1790.94 622.67 1779.35 631.28 1794.94 639.05 1806.65 630.35",
    style: {
      fill: "url(#linear-gradient-80)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1537.46 498.81 1525 492.72 1515.22 499.71 1527.82 505.99 1537.46 498.81",
    style: {
      fill: "url(#linear-gradient-81)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1752.81 642.74 1737.22 634.97 1727.37 642.3 1742.93 650.08 1752.81 642.74",
    style: {
      fill: "url(#linear-gradient-82)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1505.15 531.12 1520.72 538.91 1530.2 531.85 1514.62 524.09 1505.15 531.12",
    style: {
      fill: "url(#linear-gradient-83)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1507.94 520.76 1494.87 514.25 1485.22 521.15 1498.49 527.79 1507.94 520.76",
    style: {
      fill: "url(#linear-gradient-84)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1549.45 498.19 1565.16 505.86 1574.43 498.97 1558.76 491.26 1549.45 498.19",
    style: {
      fill: "url(#linear-gradient-85)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1669.18 539.07 1679.39 531.48 1663.42 524.01 1653.51 531.37 1669.18 539.07",
    style: {
      fill: "url(#linear-gradient-86)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1691.56 550.08 1702.2 542.16 1686.23 534.68 1675.89 542.37 1691.56 550.08",
    style: {
      fill: "url(#linear-gradient-87)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1646.81 528.07 1656.58 520.81 1640.6 513.33 1631.14 520.37 1646.81 528.07",
    style: {
      fill: "url(#linear-gradient-88)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1602.06 506.07 1610.95 499.45 1594.98 491.97 1586.39 498.36 1602.06 506.07",
    style: {
      fill: "url(#linear-gradient-89)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1624.43 517.07 1633.77 510.13 1617.79 502.65 1608.76 509.36 1624.43 517.07",
    style: {
      fill: "url(#linear-gradient-90)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.18
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 452.89,
    ry: 215.37,
    transform: "translate(-19.86 12.16) rotate(-1.5)",
    style: {
      fill: "#4c0000",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 441.22,
    ry: 209.82,
    transform: "translate(-19.86 12.16) rotate(-1.5)",
    style: {
      fill: "#4a0101",
      opacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 429.56,
    ry: 204.27,
    transform: "translate(-19.86 12.16) rotate(-1.5)",
    style: {
      fill: "#480202",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 417.89,
    ry: 198.73,
    transform: "translate(-19.86 12.16) rotate(-1.5)",
    style: {
      fill: "#460303",
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 406.22,
    ry: 193.18,
    transform: "translate(-19.86 12.16) rotate(-1.5)",
    style: {
      fill: "#440404",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 394.56,
    ry: 187.63,
    transform: "translate(-19.86 12.16) rotate(-1.5)",
    style: {
      fill: "#420505",
      opacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 382.89,
    ry: 182.08,
    transform: "translate(-19.86 12.16) rotate(-1.5)",
    style: {
      fill: "#400606",
      opacity: 0.23
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 371.23,
    ry: 176.53,
    transform: "translate(-19.86 12.16) rotate(-1.5)",
    style: {
      fill: "#3e0606",
      opacity: 0.27
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 359.56,
    ry: 170.99,
    transform: "translate(-19.86 12.16) rotate(-1.5)",
    style: {
      fill: "#3c0707",
      opacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 347.89,
    ry: 165.44,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#3a0808",
      opacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 336.23,
    ry: 159.89,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#380909",
      opacity: 0.38
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 324.56,
    ry: 154.34,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#360a0a",
      opacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 312.9,
    ry: 148.8,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#340b0b",
      opacity: 0.46
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 301.23,
    ry: 143.25,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#330c0c",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 289.57,
    ry: 137.7,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#310d0d",
      opacity: 0.54
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 277.9,
    ry: 132.15,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#2f0e0e",
      opacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 266.23,
    ry: 126.61,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#2d0f0f",
      opacity: 0.62
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.89,
    cy: 762.35,
    rx: 254.57,
    ry: 121.06,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#2b1010",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.9,
    cy: 762.35,
    rx: 242.9,
    ry: 115.51,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#291111",
      opacity: 0.69
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.9,
    cy: 762.35,
    rx: 231.24,
    ry: 109.96,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#271212",
      opacity: 0.73
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.9,
    cy: 762.35,
    rx: 219.57,
    ry: 104.41,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#251212",
      opacity: 0.77
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.9,
    cy: 762.35,
    rx: 207.9,
    ry: 98.87,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#231313",
      opacity: 0.81
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.9,
    cy: 762.35,
    rx: 196.24,
    ry: 93.32,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#211414",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.9,
    cy: 762.35,
    rx: 184.57,
    ry: 87.77,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#1f1515",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.9,
    cy: 762.35,
    rx: 172.91,
    ry: 82.22,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#1d1616",
      opacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.9,
    cy: 762.35,
    rx: 161.24,
    ry: 76.68,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#1b1717",
      opacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.9,
    cy: 762.35,
    rx: 149.57,
    ry: 71.13,
    transform: "translate(-19.86 12.15) rotate(-1.5)",
    style: {
      fill: "#191818"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1147.51,397.38c-118.86,80.05-235.24,87.71-285.22,193.26l-148.31,17.51-169.12,19.98h-.08c-61.06,2.51-125.7,80.46-134.22,181.31-5.56,65.92-33.21,106.91-63.53,118.69-2.97,1.15-5.93,2.02-8.94,2.6-.16,.04-.29,.08-.45,.08-43.34,8.16-87.96-42.97-78.98-165.33,15.98-217.81,167.88-203.85,323.74-308.86,155.89-104.97,0-240.72,0-240.72l565.12-48.53s148.93,129.69,0,230.01Z",
    style: {
      fill: "url(#linear-gradient-91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.95,578.38l-288.31,24.09c-4.22,.35-7.67-2.81-7.67-7.04h0c0-4.22,3.45-7.97,7.67-8.32l288.31-24.09c4.22-.35,7.67,2.81,7.67,7.04h0c0,4.22-3.45,7.97-7.67,8.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.47,669.04l-288.31,24.09c-4.22,.35-7.67-2.81-7.67-7.04h0c0-4.22,3.45-7.97,7.67-8.32l288.31-24.09c4.22-.35,7.67,2.81,7.67,7.04h0c0,4.22-3.45,7.97-7.67,8.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.47,729.38l-288.31,24.09c-4.22,.35-7.67-2.81-7.67-7.04h0c0-4.22,3.45-7.97,7.67-8.32l288.31-24.09c4.22-.35,7.67,2.81,7.67,7.04h0c0,4.22-3.45,7.97-7.67,8.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.01,793.49l-288.31,24.09c-4.22,.35-7.67-2.81-7.67-7.04h0c0-4.22,3.45-7.97,7.67-8.32l288.31-24.09c4.22-.35,7.67,2.81,7.67,7.04h0c0,4.22-3.45,7.97-7.67,8.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.18
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 452.89,
    ry: 215.37,
    transform: "translate(-42.27 57.95) rotate(-1.5)",
    style: {
      fill: "#4c0000",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 441.22,
    ry: 209.82,
    transform: "translate(-42.27 57.95) rotate(-1.5)",
    style: {
      fill: "#4a0101",
      opacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 429.56,
    ry: 204.27,
    transform: "translate(-42.27 57.95) rotate(-1.5)",
    style: {
      fill: "#480202",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 417.89,
    ry: 198.73,
    transform: "translate(-42.27 57.95) rotate(-1.5)",
    style: {
      fill: "#460303",
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 406.22,
    ry: 193.18,
    transform: "translate(-42.27 57.95) rotate(-1.5)",
    style: {
      fill: "#440404",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 394.56,
    ry: 187.63,
    transform: "translate(-42.27 57.95) rotate(-1.5)",
    style: {
      fill: "#420505",
      opacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 382.89,
    ry: 182.08,
    transform: "translate(-42.27 57.95) rotate(-1.5)",
    style: {
      fill: "#400606",
      opacity: 0.23
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 371.23,
    ry: 176.53,
    transform: "translate(-42.26 57.95) rotate(-1.5)",
    style: {
      fill: "#3e0606",
      opacity: 0.27
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 359.56,
    ry: 170.99,
    transform: "translate(-42.26 57.95) rotate(-1.5)",
    style: {
      fill: "#3c0707",
      opacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 347.89,
    ry: 165.44,
    transform: "translate(-42.26 57.95) rotate(-1.5)",
    style: {
      fill: "#3a0808",
      opacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 336.23,
    ry: 159.89,
    transform: "translate(-42.26 57.95) rotate(-1.5)",
    style: {
      fill: "#380909",
      opacity: 0.38
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 324.56,
    ry: 154.34,
    transform: "translate(-42.26 57.95) rotate(-1.5)",
    style: {
      fill: "#360a0a",
      opacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 312.9,
    ry: 148.8,
    transform: "translate(-42.26 57.95) rotate(-1.5)",
    style: {
      fill: "#340b0b",
      opacity: 0.46
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 301.23,
    ry: 143.25,
    transform: "translate(-42.26 57.95) rotate(-1.5)",
    style: {
      fill: "#330c0c",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 289.57,
    ry: 137.7,
    transform: "translate(-42.26 57.95) rotate(-1.5)",
    style: {
      fill: "#310d0d",
      opacity: 0.54
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 277.9,
    ry: 132.15,
    transform: "translate(-42.26 57.95) rotate(-1.5)",
    style: {
      fill: "#2f0e0e",
      opacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 266.23,
    ry: 126.61,
    transform: "translate(-42.26 57.95) rotate(-1.5)",
    style: {
      fill: "#2d0f0f",
      opacity: 0.62
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 254.57,
    ry: 121.06,
    transform: "translate(-42.26 57.95) rotate(-1.5)",
    style: {
      fill: "#2b1010",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 242.9,
    ry: 115.51,
    transform: "translate(-42.26 57.94) rotate(-1.5)",
    style: {
      fill: "#291111",
      opacity: 0.69
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 231.24,
    ry: 109.96,
    transform: "translate(-42.26 57.94) rotate(-1.5)",
    style: {
      fill: "#271212",
      opacity: 0.73
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 219.57,
    ry: 104.41,
    transform: "translate(-42.26 57.94) rotate(-1.5)",
    style: {
      fill: "#251212",
      opacity: 0.77
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 207.9,
    ry: 98.87,
    transform: "translate(-42.26 57.94) rotate(-1.5)",
    style: {
      fill: "#231313",
      opacity: 0.81
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 196.24,
    ry: 93.32,
    transform: "translate(-42.26 57.94) rotate(-1.5)",
    style: {
      fill: "#211414",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 184.57,
    ry: 87.77,
    transform: "translate(-42.25 57.94) rotate(-1.5)",
    style: {
      fill: "#1f1515",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 172.91,
    ry: 82.22,
    transform: "translate(-42.25 57.93) rotate(-1.5)",
    style: {
      fill: "#1d1616",
      opacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 161.24,
    ry: 76.68,
    transform: "translate(-42.25 57.93) rotate(-1.5)",
    style: {
      fill: "#1b1717",
      opacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2185.44,
    cy: 1638.28,
    rx: 149.57,
    ry: 71.13,
    transform: "translate(-42.25 57.93) rotate(-1.5)",
    style: {
      fill: "#191818"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.18
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.1,
    cy: 1166.35,
    rx: 452.89,
    ry: 215.37,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#4c0000",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.1,
    cy: 1166.35,
    rx: 441.22,
    ry: 209.82,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#4a0101",
      opacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.1,
    cy: 1166.35,
    rx: 429.56,
    ry: 204.27,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#480202",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.1,
    cy: 1166.35,
    rx: 417.89,
    ry: 198.73,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#460303",
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.1,
    cy: 1166.35,
    rx: 406.22,
    ry: 193.18,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#440404",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.1,
    cy: 1166.35,
    rx: 394.56,
    ry: 187.63,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#420505",
      opacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.1,
    cy: 1166.35,
    rx: 382.89,
    ry: 182.08,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#400606",
      opacity: 0.23
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.1,
    cy: 1166.35,
    rx: 371.23,
    ry: 176.53,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#3e0606",
      opacity: 0.27
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.1,
    cy: 1166.35,
    rx: 359.56,
    ry: 170.99,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#3c0707",
      opacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.1,
    cy: 1166.35,
    rx: 347.89,
    ry: 165.44,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#3a0808",
      opacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.1,
    cy: 1166.35,
    rx: 336.23,
    ry: 159.89,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#380909",
      opacity: 0.38
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 324.56,
    ry: 154.34,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#360a0a",
      opacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 312.9,
    ry: 148.8,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#340b0b",
      opacity: 0.46
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 301.23,
    ry: 143.25,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#330c0c",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 289.57,
    ry: 137.7,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#310d0d",
      opacity: 0.54
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 277.9,
    ry: 132.15,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#2f0e0e",
      opacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 266.23,
    ry: 126.61,
    transform: "translate(-30.25 29.16) rotate(-1.5)",
    style: {
      fill: "#2d0f0f",
      opacity: 0.62
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 254.57,
    ry: 121.06,
    transform: "translate(-30.25 29.15) rotate(-1.5)",
    style: {
      fill: "#2b1010",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 242.9,
    ry: 115.51,
    transform: "translate(-30.25 29.15) rotate(-1.5)",
    style: {
      fill: "#291111",
      opacity: 0.69
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 231.24,
    ry: 109.96,
    transform: "translate(-30.24 29.15) rotate(-1.5)",
    style: {
      fill: "#271212",
      opacity: 0.73
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 219.57,
    ry: 104.41,
    transform: "translate(-30.24 29.15) rotate(-1.5)",
    style: {
      fill: "#251212",
      opacity: 0.77
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 207.9,
    ry: 98.87,
    transform: "translate(-30.24 29.15) rotate(-1.5)",
    style: {
      fill: "#231313",
      opacity: 0.81
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 196.24,
    ry: 93.32,
    transform: "translate(-30.24 29.15) rotate(-1.5)",
    style: {
      fill: "#211414",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 184.57,
    ry: 87.77,
    transform: "translate(-30.24 29.15) rotate(-1.5)",
    style: {
      fill: "#1f1515",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 172.91,
    ry: 82.22,
    transform: "translate(-30.24 29.15) rotate(-1.5)",
    style: {
      fill: "#1d1616",
      opacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 161.24,
    ry: 76.68,
    transform: "translate(-30.24 29.15) rotate(-1.5)",
    style: {
      fill: "#1b1717",
      opacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.11,
    cy: 1166.35,
    rx: 149.57,
    ry: 71.13,
    transform: "translate(-30.24 29.15) rotate(-1.5)",
    style: {
      fill: "#191818"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1972.67,1373.24c-2.06,.66-4.12,1.48-6.1,2.39l-.12,.04c-57.68,26.41-89.52,147.82-200.96,209.16-6.14,3.38-12.4,6.26-18.83,8.69h-.04c-137.64,51.99-334.61-111.81-414.78-266.47-41.45-79.97-58.54-166.77-81.61-237.63-23.61-72.55-53.48-128.37-122.23-142.96-7.05-1.48-13.8-2.14-20.23-2.02l162.53-24.31,358.88-53.64,20.27-3.05c6.14-.12,12.57,.49,19.32,1.94,129.86,27.56,114.57,208.96,194.79,363.62,25.83,49.85,64.35,100.69,109.13,144.24Z",
    style: {
      fill: "url(#linear-gradient-92)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.28,920.14l-162.53,24.31c-7.42,.08-14.46,1.15-21.13,3.17h-.12c-84.54,24.8-115.97,186.26-196.52,214.48-14.17,5.03-29.91,5.85-47.75,1.07-109.3-29.37-138.71-170.56-174.06-325.84-.21-.78-.37-1.61-.58-2.43-7.79-34.15-15.9-68.97-25.21-103.41-20.35-75.15-58.17-104.89-97.52-103.37l169.12-19.98,148.31-17.51,238.7-28.18c41.24-7.66,82.52,18.99,103.78,97.56,24.6,90.88,40.33,184.57,65.51,260.13Z",
    style: {
      fill: "url(#linear-gradient-93)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1649.43,863.46l-20.27,3.05c6.43-1.94,13.14-2.97,20.27-3.05Z",
    style: {
      fill: "url(#linear-gradient-94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.69,1372.62l-1.98,.66h-.04v-.04c.66-.21,1.36-.41,2.02-.62Z",
    style: {
      fill: "url(#linear-gradient-95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2606.3,1584.18l-497.06,114.57c-31.43-49.36-28.18-134.59-35.93-205.91-1.81-16.4-4.16-32.05-7.66-46.35-8.36-34.36-23.28-60.97-52.36-71.48-14.34-5.19-26.9-5.69-38.31-2.47l13.35-4.24,493.14-96.65v.04c10.01-2.1,20.89-1.28,33.16,3.17,89.73,32.42,38.19,225.27,91.67,309.32Z",
    style: {
      fill: "url(#linear-gradient-96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.59,834.91l-.74,.21-319.82,93.03c30.32-11.78,57.97-52.77,63.53-118.69,8.53-100.85,73.17-178.8,134.22-181.31h.08c39.34-1.52,77.16,28.22,97.52,103.37,9.31,34.44,17.43,69.25,25.21,103.41Z",
    style: {
      fill: "url(#linear-gradient-97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.17,837.34l-1.32-2.22,.74-.21c.21,.82,.37,1.65,.58,2.43Z",
    style: {
      fill: "url(#linear-gradient-98)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "735.6 285.29 1124.55 250.72 1138.85 293.63 750.9 330.58 735.6 285.29",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.58,382.87l-288.31,24.09c-4.22,.35-7.67-2.81-7.67-7.04h0c0-4.22,3.45-7.97,7.67-8.32l288.31-24.09c4.22-.35,7.67,2.81,7.67,7.04h0c0,4.22-3.45,7.97-7.67,8.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.74,434.26l-288.31,24.09c-4.22,.35-7.67-2.81-7.67-7.04h0c0-4.22,3.45-7.97,7.67-8.32l288.31-24.09c4.22-.35,7.67,2.81,7.67,7.04h0c0,4.22-3.45,7.97-7.67,8.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.62,492.7l-288.31,24.09c-4.22,.35-7.67-2.81-7.67-7.04h0c0-4.22,3.45-7.97,7.67-8.32l288.31-24.09c4.22-.35,7.67,2.81,7.67,7.04h0c0,4.22-3.45,7.97-7.67,8.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.14,807.17l-288.31,24.09c-4.22,.35-7.67-2.81-7.67-7.04h0c0-4.22,3.45-7.97,7.67-8.32l288.31-24.09c4.22-.35,7.67,2.81,7.67,7.04h0c0,4.22-3.45,7.97-7.67,8.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660.45,984.54l-285.76,46.24c-4.18,.68-7.6-2.23-7.6-6.45h0c0-4.22,3.42-8.23,7.6-8.91l285.76-46.24c4.18-.68,7.6,2.23,7.6,6.45h0c0,4.22-3.42,8.23-7.6,8.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2308.35,1372.75l-184.83,40.24c-2.7,.59-4.92-2.39-4.92-6.61h0c0-4.22,2.21-8.16,4.92-8.75l184.83-40.24c2.7-.59,4.92,2.39,4.92,6.61h0c0,4.22-2.21,8.16-4.92,8.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2318.16,1419.55l-184.83,40.24c-2.7,.59-4.92-2.39-4.92-6.61h0c0-4.22,2.21-8.16,4.92-8.75l184.83-40.24c2.7-.59,4.92,2.39,4.92,6.61h0c0,4.22-2.21,8.16-4.92,8.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2327.98,1466.36l-184.83,40.24c-2.7,.59-4.92-2.39-4.92-6.61h0c0-4.22,2.21-8.16,4.92-8.75l184.83-40.24c2.7-.59,4.92,2.39,4.92,6.61h0c0,4.22-2.21,8.16-4.92,8.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2337.79,1513.16l-184.83,40.24c-2.7,.59-4.92-2.39-4.92-6.61h0c0-4.22,2.21-8.16,4.92-8.75l184.83-40.24c2.7-.59,4.92,2.39,4.92,6.61h0c0,4.22-2.21,8.16-4.92,8.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2347.6,1559.96l-184.83,40.24c-2.7,.59-4.92-2.39-4.92-6.61h0c0-4.22,2.21-8.16,4.92-8.75l184.83-40.24c2.7-.59,4.92,2.39,4.92,6.61h0c0,4.22-2.21,8.16-4.92,8.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.67,1037.83l-285.76,46.24c-4.18,.68-7.6-2.23-7.6-6.45h0c0-4.22,3.42-8.23,7.6-8.91l285.76-46.24c4.18-.68,7.6,2.23,7.6,6.45h0c0,4.22-3.42,8.23-7.6,8.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.88,1091.12l-285.76,46.24c-4.18,.68-7.6-2.23-7.6-6.45h0c0-4.22,3.42-8.23,7.6-8.91l285.76-46.24c4.18-.68,7.6,2.23,7.6,6.45h0c0,4.22-3.42,8.23-7.6,8.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.93,862.14l-288.31,24.09c-4.22,.35-7.67-2.81-7.67-7.04h0c0-4.22,3.45-7.97,7.67-8.32l288.31-24.09c4.22-.35,7.67,2.81,7.67,7.04h0c0,4.22-3.45,7.97-7.67,8.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.73,917.1l-288.31,24.09c-4.22,.35-7.67-2.81-7.67-7.04h0c0-4.22,3.45-7.97,7.67-8.32l288.31-24.09c4.22-.35,7.67,2.81,7.67,7.04h0c0,4.22-3.45,7.97-7.67,8.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.53,972.06l-288.31,24.09c-4.22,.35-7.67-2.81-7.67-7.04h0c0-4.22,3.45-7.97,7.67-8.32l288.31-24.09c4.22-.35,7.67,2.81,7.67,7.04h0c0,4.22-3.45,7.97-7.67,8.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.44,1027.03l-288.31,24.09c-4.22,.35-7.67-2.81-7.67-7.04h0c0-4.22,3.45-7.97,7.67-8.32l288.31-24.09c4.22-.35,7.67,2.81,7.67,7.04h0c0,4.22-3.45,7.97-7.67,8.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1274.48,832.86c-40.91,51.95-106.83,83.43-185.15,80.83-143.99-4.82-275.41-122.98-293.58-263.87-18.13-140.94,83.92-251.31,227.91-246.53,11.04,.37,22,1.4,32.83,3.09,83.39,12.73,159.73,62.46,208.38,130.6,27.56,38.6,46.27,83.14,52.32,130.19,8.28,64.27-8.45,122.15-42.72,165.7Z",
    style: {
      fill: "url(#linear-gradient-99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.72,811.54c-40.91,51.95-106.83,83.43-185.15,80.83-143.99-4.82-275.41-122.98-293.58-263.87-18.13-140.94,83.92-251.31,227.91-246.53,11.04,.37,22,1.4,32.83,3.09,83.39,12.73,159.73,62.46,208.38,130.6,27.56,38.6,46.27,83.14,52.32,130.19,8.28,64.27-8.45,122.15-42.72,165.7Z",
    style: {
      fill: "url(#linear-gradient-100)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.72,811.54l-217.98-174.39,208.38-121.49c27.56,38.6,46.27,83.14,52.32,130.19,8.28,64.27-8.45,122.15-42.72,165.7Z",
    style: {
      fill: "url(#linear-gradient-101)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.12,515.65l-208.38,121.49v-252.09c83.39,12.73,159.73,62.46,208.38,130.6Z",
    style: {
      fill: "url(#linear-gradient-102)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1128.86,1081.99l-288.31,24.09c-4.22,.35-7.67-2.81-7.67-7.04h0c0-4.22,3.45-7.97,7.67-8.32l288.31-24.09c4.22-.35,7.67,2.81,7.67,7.04h0c0,4.22-3.45,7.97-7.67,8.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.22,1089.43l-360.24,72.67c80.54-28.22,111.98-189.68,196.52-214.48h.12l21.13-3.17c6.43-.12,13.18,.54,20.23,2.02,68.76,14.58,98.63,70.41,122.23,142.96Z",
    style: {
      fill: "url(#linear-gradient-103)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1939.37,1395.98c-129.77-67.14-178.41-244.93-178.41-244.93l-365.44,73.79s61.75,190.16,262.51,316.56l334.25-118.8-52.91-26.62Z",
    style: {
      fill: "none",
      stroke: "#d8d8d8",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2073.32,1492.84l-326.66,100.69c6.43-2.43,12.69-5.31,18.83-8.69,111.44-61.34,143.29-182.76,200.96-209.16l.12-.04,6.1-2.35h.04l1.98-.66,.29-.08c11.41-3.21,23.98-2.72,38.31,2.47,29.09,10.51,44,37.12,52.36,71.48,3.5,14.3,5.85,29.95,7.66,46.35Z",
    style: {
      fill: "url(#linear-gradient-104)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2107.94,1699.5c-18.84-32.84-25.73-92.45-32.4-150.1-7.7-66.57-15.66-135.4-41.98-160.76-11.8-11.37-24.93-16.49-39-15.21-37.83,3.44-76.24,51.25-101.83,86.91-2.77,3.86-5.8,8.29-9.31,13.42-20.43,29.86-51.3,75-96.93,104.78-29.77,19.43-61.45,29.16-94.78,29.16-28.22,0-57.61-6.97-88.03-20.93-81.24-37.28-151.08-92.12-207.57-163-54.24-68.06-94.5-148.64-119.65-239.51-50.22-181.45-90.9-234.44-181.39-236.28-.34,0-.67-.01-1.01-.01-42.62,0-76.97,54.8-110.19,107.8-34.8,55.52-70.68,112.76-117.88,112.76-5.02,0-10.15-.65-15.44-2.01-100.73-25.97-131.91-135.27-168.02-261.81l-2.37-8.31c-8.44-29.54-15.39-57.69-22.11-84.92-22.15-89.77-39.65-160.68-88.28-178.32-21.89-7.94-44.37-5.88-65.01,5.97-43.6,25.02-77.14,90.91-94.46,185.54-6.49,35.44-18.48,63.97-34.69,82.5-14.62,16.71-32.51,24.94-50.37,23.16-19.06-1.9-36.5-14.7-49.11-36.03-13.76-23.29-20.7-54.8-20.05-91.1,1.31-73.22,15.46-127.03,44.54-169.35,26.41-38.44,65.86-68.84,127.89-98.57,9.67-4.63,19.09-9.1,28.25-13.45,96.35-45.71,165.96-78.74,189.44-145.84,13.18-37.66-5.1-78.84-22.76-106.75-19.23-30.39-41.88-52.04-42.1-52.26l2.07-2.17c.23,.22,23.15,22.13,42.57,52.83,25.83,40.83,33.81,78.64,23.06,109.34-11.06,31.59-32.58,57.64-67.72,81.99-32.41,22.46-74.52,42.44-123.27,65.57-9.16,4.35-18.58,8.81-28.24,13.45-106.04,50.82-167.97,110.51-170.73,265.27-.64,35.75,6.15,66.71,19.63,89.52,12.11,20.49,28.74,32.77,46.83,34.58,28.49,2.84,67.03-22.48,81.8-103.21,17.48-95.51,51.54-162.14,95.92-187.6,21.43-12.29,44.78-14.43,67.52-6.19,50.14,18.18,67.81,89.78,90.18,180.42,6.71,27.2,13.65,55.32,22.08,84.81l2.37,8.31c35.86,125.66,66.82,234.19,165.88,259.73,52.88,13.63,92.1-48.93,130.03-109.45,16.93-27.01,34.44-54.95,52.85-75.41,20.83-23.15,40.74-34.17,60.95-33.79,48.95,.99,81.55,16.9,109.03,53.2,26.42,34.9,48.91,90.31,75.19,185.28,51.35,185.55,166.98,327.81,325.57,400.58,151.76,69.63,235.68-53.03,276-111.98,3.52-5.15,6.56-9.59,9.35-13.48,25.94-36.14,64.95-84.6,104-88.15,14.99-1.36,28.9,4.03,41.36,16.04,27.09,26.11,35.12,95.49,42.88,162.58,6.63,57.35,13.49,116.65,32.02,148.95l-2.6,1.49Z",
    style: {
      fill: "url(#linear-gradient-105)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1426.66,
    y1: 1293.55,
    x2: 1784.47,
    y2: 1213.69,
    style: {
      fill: "none",
      stroke: "#d8d8d8",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.75,1213.69s80.44,203.61,264.09,307.52",
    style: {
      fill: "none",
      stroke: "#d8d8d8",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595.63,1184.43s104.74,225.76,252.14,289.53",
    style: {
      fill: "none",
      stroke: "#d8d8d8",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1770.43,
    y1: 1179.43,
    x2: 1610.5,
    y2: 1213.69,
    style: {
      fill: "none",
      stroke: "#d8d8d8",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.9,1195.82s79.78,173.66,216.09,231.29",
    style: {
      fill: "none",
      stroke: "#d8d8d8",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1477.36,
    y1: 1373.28,
    x2: 1820.67,
    y2: 1281,
    style: {
      fill: "none",
      stroke: "#d8d8d8",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1559.35,
    y1: 1465.34,
    x2: 1882.48,
    y2: 1355.77,
    style: {
      fill: "none",
      stroke: "#d8d8d8",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2517.52,1395.41c-13.35-22.58-36.25-39.01-62.7-43.26-3.46-.54-6.92-.91-10.51-1.03-46.27-1.57-82.97,34.98-81.94,81.65,1.03,46.64,39.34,85.73,85.61,87.34,25.17,.86,47.5-9.56,62.5-26.78,12.52-14.38,19.94-33.58,19.45-54.83-.33-15.57-4.82-30.32-12.4-43.09Zm-70.41,83.96c-23.98-.82-43.83-21.09-44.37-45.24-.49-24.14,18.5-43.09,42.48-42.27,1.81,.08,3.63,.25,5.44,.54,13.68,2.18,25.54,10.71,32.46,22.41,3.91,6.59,6.26,14.25,6.43,22.29,.25,11.04-3.58,20.97-10.09,28.43-7.75,8.9-19.32,14.3-32.34,13.84Z",
    style: {
      fill: "url(#linear-gradient-106)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2529.92,1438.5c.49,21.26-6.92,40.46-19.45,54.83l-31.02-27.81c6.51-7.46,10.34-17.39,10.09-28.43-.16-8.03-2.51-15.7-6.43-22.29l34.4-19.4c7.58,12.77,12.07,27.52,12.4,43.09Z",
    style: {
      fill: "url(#linear-gradient-107)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2517.52,1395.41l-34.4,19.4c-6.92-11.7-18.79-20.23-32.46-22.41l4.16-40.25c26.45,4.24,49.36,20.68,62.7,43.26Z",
    style: {
      fill: "url(#linear-gradient-108)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2146.46,1190.6c-4.37,5.52-9.15,10.71-14.34,15.49-27.07,25.13-64.89,39.59-108.47,38.15-95.54-3.21-182.71-81.57-194.79-175.05-5.19-40.54,4.57-77.29,25.17-105.63,9.56-13.22,21.46-24.6,35.31-33.74t.08-.04c24.88-16.36,55.91-25.3,90.64-24.14,7.33,.25,14.58,.95,21.79,2.06,55.33,8.45,105.96,41.45,138.22,86.64,14.38,20.15,25.13,42.76,31.02,66.66,1.61,6.47,2.84,13.02,3.71,19.69,5.48,42.64-5.6,81.04-28.34,109.92Z",
    style: {
      fill: "url(#linear-gradient-109)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2164.5,1176.47c-9.06,11.49-19.94,21.51-32.38,29.62-24.84,16.27-55.82,25.13-90.43,24.02-95.5-3.21-182.67-81.61-194.74-175.05-3.17-24.55-.82-47.71,6.06-68.43,7.33-22.08,19.82-41.4,36.34-56.81t.08-.04c27.11-25.17,65.01-39.72,108.72-38.27,7.33,.25,14.58,.95,21.79,2.06,55.29,8.45,105.92,41.4,138.22,86.64,12.57,17.59,22.37,37.04,28.55,57.64,2.84,9.35,4.9,18.95,6.14,28.72,5.52,42.64-5.6,81.04-28.34,109.92Z",
    style: {
      fill: "url(#linear-gradient-110)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2186.71,1037.84c-4.33,8.16-9.56,15.9-15.61,23.15-31.39,37.74-84.17,62.5-143.99,62.5-93.64,0-170.03-60.73-174.1-136.86-.12-2.1-.16-4.24-.16-6.39,0-5.64,.41-11.21,1.19-16.69,9.56-13.22,21.46-24.6,35.31-33.74t.08-.04c27.11-25.17,65.01-39.72,108.72-38.27,7.33,.25,14.58,.95,21.79,2.06,55.29,8.45,105.92,41.4,138.22,86.64,12.57,17.59,22.37,37.04,28.55,57.64Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2016.79,1018.72c0,30.2-15.87,45.19-34.39,45.19s-33.29-14.33-33.51-43.21c0-28.66,15.65-44.75,34.61-44.75,20.06,0,33.29,15.43,33.29,42.77Zm-52.47,1.32c-.44,18.3,6.39,32.19,18.52,32.19,12.79,0,18.52-13.67,18.52-32.63,0-17.42-5.07-31.97-18.52-31.97-12.12,0-18.52,14.33-18.52,32.41Zm16.76,104.06l84.22-148.15h12.35l-84.22,148.15h-12.35Zm128.97-46.08c0,30.2-15.87,45.2-34.17,45.2s-33.29-14.33-33.51-42.99c0-28.88,15.65-44.97,34.61-44.97,20.06,0,33.07,15.43,33.07,42.77Zm-52.47,1.32c-.22,18.3,6.83,32.19,18.74,32.19,12.79,0,18.52-13.67,18.52-32.63,0-17.42-5.07-31.97-18.52-31.97-12.13,0-18.74,14.33-18.74,32.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1786.02,334.53l-179.11-61.3c-2.6-.89-4.26-3.74-3.68-6.32h0c.58-2.59,3.18-3.98,5.78-3.08l179.11,61.3c2.6,.89,4.26,3.74,3.68,6.32h0c-.58,2.59-3.18,3.98-5.78,3.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780.37,359.81l-179.11-61.3c-2.6-.89-4.26-3.74-3.68-6.32h0c.58-2.59,3.18-3.98,5.78-3.08l179.11,61.3c2.6,.89,4.26,3.74,3.68,6.32h0c-.58,2.59-3.18,3.98-5.78,3.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.71,385.09l-179.11-61.3c-2.6-.89-4.26-3.74-3.68-6.32h0c.58-2.59,3.18-3.98,5.78-3.08l179.11,61.3c2.6,.89,4.26,3.74,3.68,6.32h0c-.58,2.59-3.18,3.98-5.78,3.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.05,410.37l-179.11-61.3c-2.6-.89-4.26-3.74-3.68-6.32h0c.58-2.59,3.18-3.98,5.78-3.08l179.11,61.3c2.6,.89,4.26,3.74,3.68,6.32h0c-.58,2.59-3.18,3.98-5.78,3.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.1,417.41l-125.82-43.06c-2.6-.89-4.26-3.74-3.68-6.32h0c.58-2.59,3.18-3.98,5.78-3.08l125.82,43.06c2.6,.89,4.26,3.74,3.68,6.32h0c-.58,2.59-3.18,3.98-5.78,3.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1672.29 214.01 1642.32 204.36 1654.97 134.93 1684.94 144.58 1672.29 214.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1720.65 229.59 1690.67 219.94 1708.96 119.58 1738.93 129.23 1720.65 229.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1769 245.16 1739.03 235.51 1762.72 105.48 1792.69 115.14 1769 245.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1817.35 260.74 1787.38 251.08 1802.68 167.13 1832.65 176.79 1817.35 260.74",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1984.94,207.56l-112.38-38.26c-2.33-.8-3.81-3.34-3.29-5.66h0c.52-2.31,2.85-3.56,5.17-2.76l112.38,38.26c2.33,.8,3.81,3.34,3.29,5.66h0c-.52,2.31-2.85,3.56-5.17,2.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.88,230.18l-112.38-38.26c-2.33-.8-3.81-3.34-3.29-5.66h0c.52-2.31,2.85-3.56,5.17-2.76l112.38,38.26c2.33,.8,3.81,3.34,3.29,5.66h0c-.52,2.31-2.85,3.56-5.17,2.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.82,252.8l-112.38-38.26c-2.33-.8-3.81-3.34-3.29-5.66h0c.52-2.31,2.85-3.56,5.17-2.76l112.38,38.26c2.33,.8,3.81,3.34,3.29,5.66h0c-.52,2.31-2.85,3.56-5.17,2.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1969.76,275.41l-112.38-38.26c-2.33-.8-3.81-3.34-3.29-5.66h0c.52-2.31,2.85-3.56,5.17-2.76l112.38,38.26c2.33,.8,3.81,3.34,3.29,5.66h0c-.52,2.31-2.85,3.56-5.17,2.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1917.02,281.71l-64.7-21.94c-2.33-.8-3.81-3.34-3.29-5.66h0c.52-2.31,2.85-3.56,5.17-2.76l64.7,21.94c2.33,.8,3.81,3.34,3.29,5.66h0c-.52,2.31-2.85,3.56-5.17,2.76Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1872.08,334.8c-43.27,0-78.34,35.07-78.34,78.34s35.07,78.34,78.34,78.34,78.34-35.07,78.34-78.34-35.07-78.34-78.34-78.34Zm0,123.49c-24.94,0-45.15-20.21-45.15-45.15,0-24.94,20.21-45.15,45.15-45.15s45.15,20.21,45.15,45.15c0,24.94-20.21,45.15-45.15,45.15Z",
    style: {
      fill: "url(#linear-gradient-111)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.02,1289.64l317.5-93.93c17.66-5.22,36.49,3.2,44.37,19.85l129.8,274.34c9.34,19.74-.6,43.22-21.28,50.25l-307.17,104.39c-23.41,7.96-49.04-3.17-59.21-25.7l-126.49-280.11c-8.94-19.8,1.66-42.93,22.48-49.09Z",
    style: {
      fill: "url(#linear-gradient-112)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "923.43 1511.76 880.57 1525.79 836.81 1434.68 879.67 1420.65 923.43 1511.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "992.57 1489.13 949.71 1503.16 886.46 1371.46 929.32 1357.43 992.57 1489.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1061.71 1466.49 1018.85 1480.52 936.9 1309.89 979.76 1295.86 1061.71 1466.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1130.86 1443.85 1088 1457.88 1035.09 1347.72 1077.95 1333.69 1130.86 1443.85",
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.babfd031e3697df96060fc485ebc029d.svg";
export { ForwardRef as ReactComponent };